<template>
    <button type="button" class="more outline" @click.prevent="handleImport" v-if="showImportButton" :class="{loading: isImportLoading}">
        <span class="title">{{ trans("Import") }}</span>
        <span class="loader" v-if="isImportLoading"></span>
    </button>
    <button type="button" class="more outline" @click.prevent="handleExport" v-if="showExportButton" :class="{loading: isExportLoading}">
        <span class="title">{{ trans("Export") }}</span>
        <span class="loader" v-if="isExportLoading"></span>
    </button>
    <Teleport to="body">
        <input ref="excelUploadRef" type="file" accept=".xls,.xlsx" style="display: none;" @change.prevent="handleExcelImport" />
    </Teleport>
    <Popup v-if="popupVisibility.success" :closeButton="false" :togglePopup="() => togglePopup('success')"
           classlist="Success Detail small centered">
        <div class="Heading">
            <h1 class="h1">{{ trans("Uw export is aangevraagd") }}</h1>
        </div>
        <div class="inner">
            <nav>
                <button type="button" class="more" @click.prevent="togglePopup('success')">
                    <span class="title">{{ trans("Ok") }}</span>
                </button>
            </nav>
        </div>
    </Popup>
<!--    <Teleport to="body">-->
<!--    <dashboard-modal-->
<!--        :uppy="uppy"-->
<!--        :open="isUppyOpen"-->
<!--        :props="{-->
<!--            closeModalOnClickOutside: true,-->
<!--            theme: 'light',-->
<!--        }"-->
<!--    />-->
<!--    </Teleport>-->
</template>

<script>

import {defineComponent, onMounted, onUnmounted, reactive, inject, watch, ref, provide, computed} from "vue";

import trans from "helpers/_translation";
import {getQuery} from "helpers/_structure";

import {postDataAsync, getDataAsync, fetchDataAsync} from "helpers/_api";
import { refreshToken , getBearer } from "services/JwtService";

import { me } from "store/portal";

// Config for API urls used in this vue template
import { config, apiHostname } from "config";

// Components
import Popup from "components/popup";
import Icon from "components/icon.vue";

// External components
import { DashboardModal } from '@uppy/vue';

import { item } from "store/portal";

import Uppy from '@uppy/core';
import Dutch from '@uppy/locales/lib/nl_NL';
import Tus from '@uppy/tus';

export default defineComponent({
    name: "workflowphase-overview",
    components: {
        Icon,
        Popup,

        DashboardModal
    },
    emits: ["updateUpload"],
    props: {
        workflowboard_id: {
            type: String,
            required: true
        },
        workflowphases: {
            type: Array,
            required: false,
            default: () => []
        }
    },
    setup(props, { emit }) {
        // Check for filters in case
        const generalFilters = inject("generalFilters");

        const excelUploadRef = ref();


        // Define resolved types for each key
        // const types = {
        //     "restrictions": {
        //         "array": [
        //             "allowed_file_types"
        //         ],
        //         "number": [
        //             "max_file_size",
        //             "max_number_of_files"
        //         ]
        //     },
        //     "meta": {
        //         "number": [
        //             "column_uploadfolder_id"
        //         ],
        //         "string": [
        //             "entity",
        //             "module_object",
        //             "item_id"
        //         ]
        //     }
        // };
        // const resolveType = (key, target) => {
        //     return Object.keys(types[target]).filter(type => { return types[target][type].includes(key)})?.[0];
        // };
        // const resolveParams = (target) => {
        //     Object.keys(props).forEach(key => {
        //         let val;
        //         switch (resolveType(key, target)) {
        //             case 'number':
        //                 val = Number(props[key]);
        //                 break;
        //             case 'array':
        //                 val = props[key].split(",");
        //                 break;
        //             case 'string':
        //                 val = props[key];
        //                 break;
        //         }
        //         val && (data[target][key] = val);
        //     });
        // };
        //
        // const data = {
        //     "restrictions": {},
        //     "meta": {}
        // };
        // // Store the data
        // Object.keys(data).forEach(resolveParams);


        // const isUppyOpen = ref(false);

        const addNotification = inject("addNotification");

        const workflowboard = computed(() => {
            return item("workflowboard", props.workflowboard_id);
        });

        const importLoading = ref(false);
        const importTemplateId = ref();
        const isImportLoading = computed(() => {
            return importLoading.value;
        });
        const handleImport = (e) => {
            const workflowboardimporttemplateId = workflowboard.value?.data?.workflowimportertemplate_id;
            if (!workflowboardimporttemplateId) return;

            // Open uppy
            // isUppyOpen.value = true;

            // Store current ID for reference
            importTemplateId.value = workflowboardimporttemplateId;
            // Execute file upload field
            const target = excelUploadRef.value;
            target && target?.click();
        };

        const handleExcelImport = (e) => {
            const file = e.target.files[0];

            if (!file) return;

            const allowedTypes = [
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            ];

            if (!allowedTypes.includes(file.type)) {
                addNotification(trans("Alleen Excel bestanden zijn toegestaan. (.xls, .xlsx)"), 3500);
                return;
            }

            // Prepare FormData
            const formData = new FormData();
            formData.append('file', file);

            console.log("formData",formData);
            importLoading.value = true;
            addNotification(trans("De bestandsupload wordt gestart..."), 3500);

            fetch(`${apiHostname}/api/v1.0/workflowimportertemplate/${importTemplateId.value}/upload`, {
                method: 'POST',
                headers: {
                    ...getBearer()
                },
                body: formData
            }).then((result) => {
                result.json().then(json => {
                    const targetId = json.data.id;
                    if (!targetId) {
                        addNotification(trans("De bestandsupload is mislukt. Probeer het later nog eens."), 3500);
                        return;
                    }
                    addNotification(trans("De import is geslaagd."), 3500);
                    importLoading.value = false;
                    // postDataAsync(`${apiHostname}/api/v1.0/workflowimporter/${targetId}/execute`).then(() => {
                    //     addNotification(trans("De import wordt uitgevoerd..."), 3500);
                    //
                    //     // Interval and get percentage
                    //     const interval = setInterval(() => {
                    //         getDataAsync(`${apiHostname}/api/v1.0/workflowimportertemplate/${importTemplateId.value}`).then(state => {
                    //             addNotification(trans("De import is geslaagd."), 3500);
                    //             console.log("state", state);
                    //             // if (result3 && result3._meta && result3._meta.status && result3._meta.status !== "pending") {
                    //             //     clearInterval(interval);
                    //             //     importLoading.value = false;
                    //             //     isUppyOpen.value = false;
                    //             // }
                    //         });
                    //     }, 500);
                    // });
                });
            });
        };



        // let timeout = false;
        // const uppy = new Uppy({
        //     id: "VueUppy",
        //     locale: Dutch,
        //     autoProceed: true,
        //     allowMultipleUploadBatches: false,
        //     restrictions: data.restrictions,
        //     meta: data.meta,
        //     onBeforeFileAdded: (currentFile, files) => {
        //         currentFile.meta.name = currentFile.name.replaceAll("&", "").replaceAll(",", "");
        //         return currentFile;
        //     }
        // })
        //     .use(Tus, {
        //         endpoint: `${apiHostname}${config.upload.file_url}`,
        //         retryDelays: [0, 1000, 3000, 5000],
        //         chunkSize: 5000 * 1000,
        //         headers: getBearer(),
        //         removeFingerprintOnSuccess: true
        //     })
        //     .on('dashboard:modal-closed', () => {
        //         isUppyOpen.value = false;
        //     })
        //     .on('complete', tus_result => {
        //         console.log('successful files:', tus_result.successful);
        //         console.log('failed files:', tus_result.failed);
        //         const getPromises = [];
        //         tus_result.successful.forEach(upload => {
        //             const tmpPromise = new Promise(resolve => {
        //                 getDataAsync(upload.uploadURL).then(upload_result => {
        //                     resolve(upload_result);
        //                 });
        //             });
        //             getPromises.push(tmpPromise);
        //         });
        //         Promise.all(getPromises).then((result) => {
        //             console.log("result",result);
        //
        //             postDataAsync(`${apiHostname}/api/v1.0/workflowimporttemplate/${importTemplateId.value}/upload`, {
        //                 filepath: result._meta.url
        //             }).then((upload) => {
        //                 importLoading.value = false;
        //                 isUppyOpen.value = false;
        //                 console.log("upload", upload);
        //             }).catch(() => {
        //                 importLoading.value = false;
        //                 isUppyOpen.value = false;
        //             });
        //
        //             emit('updateUpload', tus_result, result);
        //         });
        //     })
        //     .on('upload-error', (file, error, response) => {
        //         if (!response && error.message.includes("response code: 401")) {
        //             uppy.pauseAll();
        //             if (!timeout) {
        //                 timeout = true;
        //                 refreshToken().then(() => {
        //                     uppy.getPlugin('Tus').setOptions({
        //                         headers: getBearer()
        //                     });
        //                     uppy.retryUpload(file.id);
        //                     setTimeout(() => { timeout = false; }, 500);
        //                 });
        //             }
        //         }
        //     });

        const workflowphases = computed(() => props.workflowphases);

        const exportLoading = ref(false);
        const isExportLoading = computed(() => {
            return exportLoading.value;
        });
        const handleExport = (e) => {
            exportLoading.value = true;
            let tmpGeneralFilters = [];
            if (generalFilters?.workflowboard) {
                Object.keys(generalFilters.workflowboard).forEach(key => {
                    const value = generalFilters.workflowboard[key];
                    // Check if the value is an array
                    if (Array.isArray(value)) {
                        value.forEach(item => {
                            if (item?.data?.filter_json) {
                                JSON.parse(item.data.filter_json).filters.forEach(function (filter) {
                                    tmpGeneralFilters.push(filter);
                                });
                            }
                        });
                    }
                });
            }
            if (generalFilters?.workflowusergroup) {
                Object.keys(generalFilters.workflowusergroup).forEach(key => {
                    const item = generalFilters.workflowusergroup[key];
                    if (item?.data?.filter_json) {
                        JSON.parse(item.data.filter_json).filters.forEach(function (filter) {
                            tmpGeneralFilters.push(filter);
                        });
                    }
                });
            }
            tmpGeneralFilters.push({
                "t" : "FieldFilter",
                "c" : "state",
                "v" : "Online",
                "o" : "="
            });
            Object.keys(getQuery()).forEach(key => {
                const value = getQuery(key);
                let values = [value];
                if (value.includes(",")) {
                    values = value.split(",");
                }

                tmpGeneralFilters.push({
                    "t" : "StudioIbizz\\Workflowproperty\\Filters\\Workflowproperty",
                    "c" : key,
                    "v" : values,
                    "o" : "IN"
                });
            });

            let tmpExportFilters = {
                "multi": {},
            };
            workflowphases.value && Object.values(workflowphases.value).forEach(workflowphase => {
                if (parseInt(workflowphase.workflowboard_id) === parseInt(props.workflowboard_id)) {
                    let tmpColumnFilters = [];
                    workflowphase.extra.workflowfilter.forEach(workflowFilter => {
                        if (workflowFilter.filter_json) {
                            let filterData = JSON.parse(workflowFilter.filter_json).filters;
                            if (Array.isArray(filterData)) {
                                filterData.forEach(filter => {
                                    tmpColumnFilters.push(filter);
                                })
                            }
                        }
                    });
                    tmpExportFilters["multi"][workflowphase.title] = [...tmpColumnFilters, ...tmpGeneralFilters];
                }
            });

            let jsonData = {
                "fileType": "xlsx",
                "exportType": "Workflowcard",
                "moduleObject": "Export",
                "filters": tmpExportFilters,
                "notificationEmail": me.value.data.email
            };

            postDataAsync(`${apiHostname}${config.value.export.url}`, jsonData).then(result => {
                if (result && result._meta && result._meta.download_url) {
                    handleExportFinished(result.data.id, result._meta.download_url, 20);
                } else {
                    isExportLoading.value = false;
                    togglePopup('error');
                }
            })
        };

        const handleExportFinished = (downloadId, downloadUrl, counter) => {
            if (counter === 0) {
                isExportLoading.value = false;
                togglePopup('error');
                return;
            }

            fetchDataAsync(`${apiHostname}${config.value.export.url}/${downloadId}`).then(result => {
                if (result && result._meta && result._meta.status && result._meta.status !== "pending") {
                    if (result._meta.status == "complete") {
                        handleExportDownload(downloadUrl, 10);
                        return;
                    } else if (result._meta.status == "failed") {
                        counter = 0;
                        isExportLoading.value = false;
                        togglePopup('error');
                        return;
                    }
                }

                setTimeout(function () {
                    counter = (counter - 1);
                    handleExportFinished(downloadId, downloadUrl, counter);
                    exportLoading.value = false;
                }, 500);
            });
        };

        const handleExportDownload = (downloadUrl, counter) => {
            if (counter === 0) {
                isExportLoading.value = false;
                togglePopup('error');
                return;
            }

            fetchDataAsync(downloadUrl).then(download => {
                window.open(download.url);
                togglePopup('success');
            }).catch(error => {
                setTimeout(function () {
                    counter = (counter - 1);
                    handleExportDownload(downloadUrl, counter);
                }, 500);
            })
        };


        const showImportButton = computed(() => {
            return (workflowboard.value?.data?.workflowcard_show_importbutton === "Y")
                && !!workflowboard.value?.extra?.permissions?.import
                && !!workflowboard.value?.data?.workflowimportertemplate_id
        });
        const showExportButton = computed(() => {
            return (workflowboard.value?.data?.workflowcard_show_exportbutton === "Y")
                && !!workflowboard.value?.extra?.permissions?.export;
        });

        // Our popup related code, every action_type can have it's own popup with diffent data based on action clicked
        const popupVisibility = reactive({
            success: false
        });
        const togglePopup = (trigger) => {
            popupVisibility[trigger] = !popupVisibility[trigger];
            popupVisibility[trigger] ? document.body.classList.add("VuePopupOpen") : document.body.classList.remove("VuePopupOpen");
        };

        return {
            trans,

            isImportLoading,
            showImportButton,
            handleImport,

            isExportLoading,
            showExportButton,
            handleExport,

            // uppy,
            // isUppyOpen,

            excelUploadRef,
            handleExcelImport,

            popupVisibility,
            togglePopup
        };
    },
});

</script>